import { render, staticRenderFns } from "./answer_record.vue?vue&type=template&id=668fa3f8&scoped=true&"
import script from "./answer_record.vue?vue&type=script&lang=js&"
export * from "./answer_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668fa3f8",
  null
  
)

export default component.exports